// extracted by mini-css-extract-plugin
export default {"emptyList":"ArchiveModal_emptyList__hCFkc","archiveTable":"ArchiveModal_archiveTable__fREL9"};